import TransactionDetailsSubHeader from './TransactionDetailsSubHeader'

export default TransactionDetailsSubHeader
